export const modalBundle = {
  title: { ko: "상세 정보", en: "Detailed Information", es: "Información detallada" },
  userHeader: {
    title: { ko: "수용가 정보", en: "Customer Information", es: "Información del cliente" },
    rows: [
      { key: "customer_id", label: { ko: "수용가번호", en: "Customer ID", es: "N.° de cliente" } },
      {
        key: "customer_name",
        label: { ko: "고객명", en: "Customer Name", es: "Nombre del cliente" }
      },
      {
        key: "caliber",
        label: { ko: "구경(mm)", en: "Meter Diameter (mm)", es: "Diámetro del medidor (mm)" }
      },
      { key: "address", label: { ko: "주소", en: "Address", es: "Dirección" } },
      { key: "block_mid", label: { ko: "중블럭", en: "Middle Block", es: "Bloque medio" } },
      { key: "office", label: { ko: "사업소", en: "Office", es: "Oficina" } }
    ]
  },
  infoHeader: {
    title: { ko: "주간 누수 정보", en: "Weekly Leak Summary", es: "Resumen semanal de fugas" },
    rows: [
      {
        key: "leak_start_at",
        label: { ko: "누수시작시점", en: "Leak Start Time", es: "Hora de inicio de fuga" }
      },
      {
        key: "leak_volume",
        label: { ko: "누수량 (m³)", en: "Leak Volume (m³)", es: "Volumen de fuga (m³)" }
      },
      { key: "usage_volume", label: { ko: "사용량 (m³)", en: "Usage (m³)", es: "Consumo (m³)" } },
      {
        key: "leak_rate",
        label: { ko: "누수율 (%)", en: "Leak Rate (%)", es: "Tasa de fuga (%)" }
      },
      { key: "leak_type", label: { ko: "누수유형", en: "Leak Type", es: "Tipo de fuga" } },
      {
        key: "leak_severity",
        label: { ko: "누수심각도", en: "Leak Severity", es: "Gravedad de la fuga" }
      }
    ]
  },
  hours: { ko: "시", en: "H", es: "H" }
}
